import { Component, Input } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { Product } from '../../models/Product';
import { SoftwareService } from '../../shared/software.service';
import { AuthService } from '../../shared/auth.service';
import { Router } from '@angular/router';

@Component({
    selector: 'products',
    providers: [AuthService], 
    templateUrl: './products.component.html',
    styleUrls: ['./products.component.css']
})
export class ProductsComponent {
    releaseStatus = [
        ['Prototype', 0],
        ['Alpha', 1],
        ['Beta', 2],
        ['Internal', 3],
        ['Dealership', 4],
        ['Production', 5],
        ['Obsolete', 6]
        ];

    products: Product[] = [];

    busy: boolean = false;

    constructor(private softwareService: SoftwareService, public auth: AuthService, public snackBar: MdSnackBar, private router: Router) {
        this.busy = true;
        this.getProducts();
    }

    getProducts() {
        this.softwareService.getProducts().subscribe(result => {
            this.products = result.json();
            this.busy = false;
        }, err => {
            this.busy = false;
            this.products = [];
            this.snackBar.open('Error loading products', null, { duration: 3000 });
        });
    }

    viewProduct(id: number) {
        this.router.navigate(['/product', id]);
    }
}



// WEBPACK FOOTER //
// ./Client/app/containers/products/products.component.ts